export default "__VITE_ASSET__BoNuGxGw__"